<template>
  <div
    class="u-avatar"
    :class="{
      'u-avatar_rounded': rounded,
      'u-avatar_bordered': bordered,
    }"
    :style="{ width: size && `${size}px` }"
  >
    <div
      class="u-avatar__img"
      :style="{ backgroundImage: img && `url(${img})` }"
    ></div>
    <svg
      class="u-avatar__svg"
      viewBox="0 0 40 40"
      width="40"
      height="40"
    >
      <text
        x="50%"
        y="26"
        height="20"
        text-anchor="middle"
      >
        {{ initials }}
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    username: String,
    size: Number,
    rounded: {
      type: Boolean,
      default: true,
    },
    bordered: Boolean,
    img: String,
  },
  computed: {
    initials() {
      if (!this.username) {
        return null;
      }
      const name = this.username.trim().split(' ');
      if (name.length < 2) {
        return name[0][0];
      }
      return name[0][0] + name[name.length - 1][0];
    },
  },
};
</script>

<style lang="scss">
  @import "./Avatar";
</style>
